import React from "react";
import { Box, HStack } from "components/ui";
import { Item } from "store/abcoApi";
import { renderItemContent, renderItemImage } from "./ItemListItemBase";

type Props = {
	item: Item;
	showAlternatives?: boolean;
};

export const ItemAlternativeDisplay = ({ item, showAlternatives = true }: Props) => {
	return (
		<Box paddingHorizontal={20}>
			<HStack w={"$full"} paddingVertical={28} gap={20} borderBottomWidth={1} borderBottomColor="$neutral100">
				{renderItemImage(item)}
				<Box flex={2} justifyContent="center">
					{renderItemContent(item)}
				</Box>
			</HStack>
		</Box>
	);
};
